import { SvgIcon } from "@mui/material";
import type React from "react";

export const ErrorIcon = (props: React.ComponentProps<typeof SvgIcon>) => (
  <SvgIcon {...props} viewBox="0 0 19 17">
    <path
      d="M18.3578 11.8854L11.6703 1.125C11.139 0.40625 10.3265 0 9.45152 0C8.54527 0 7.73277 0.40625 7.23277 1.125L0.54527 11.8854C-0.0797305 12.7292 -0.173481 13.8229 0.29527 14.7604C0.76402 15.6979 1.70152 16.2917 2.76402 16.2917H16.139C17.2015 16.2917 18.139 15.6979 18.6078 14.7604C19.0765 13.8542 18.9828 12.7292 18.3578 11.8854ZM17.3578 14.1354C17.1078 14.6042 16.6703 14.8854 16.139 14.8854H2.76402C2.23277 14.8854 1.79527 14.6042 1.54527 14.1354C1.32652 13.6667 1.35777 13.1354 1.67027 12.7292L8.35777 1.96875C8.60777 1.625 9.01402 1.40625 9.45152 1.40625C9.88902 1.40625 10.2953 1.59375 10.5453 1.96875L17.2328 12.7292C17.5453 13.1354 17.5765 13.6667 17.3578 14.1354Z"
      fill="currentColor"
    />
    <path
      d="M9.45148 5.8125C9.07648 5.8125 8.73273 6.125 8.73273 6.53125V9.9375C8.73273 10.3125 9.04523 10.6562 9.45148 10.6562C9.85773 10.6562 10.1702 10.3438 10.1702 9.9375V6.5C10.1702 6.125 9.82648 5.8125 9.45148 5.8125Z"
      fill="currentColor"
    />
    <path
      d="M9.45148 11.4792C9.07648 11.4792 8.73273 11.7917 8.73273 12.198V12.3542C8.73273 12.7292 9.04523 13.073 9.45148 13.073C9.85773 13.073 10.1702 12.7605 10.1702 12.3542V12.1667C10.1702 11.7917 9.82648 11.4792 9.45148 11.4792Z"
      fill="currentColor"
    />
  </SvgIcon>
);
